export const domain = 'Notification';

// action types
export const DISABLE_NOTIFICATION = `${domain}/DISABLE_NOTIFICATION`;
export const SHOW_NOTIFICATION = `${domain}/SHOW_NOTIFICATION`;
